module.exports = __webpack_public_path__ + "static/media/pdp_moto_banner-mob.2bc5de77.png";